// Action creator to initialize analytics.
// @flow
import { ACTIONS } from '../actions';
import type {
    TitleState,
    ColumnState,
    RowState,
    GraphState,
    KpiState
} from '../constants';

export const initialize = (
    title: TitleState,
    columns: ColumnState,
    rows: RowState,
    defaultSort: {},
    graphData: GraphState,
    kpi: KpiState
) => {
    return {
        columns,
        rows,
        title,
        defaultSort,
        graphData,
        kpi,
        type: ACTIONS.INITIALIZE
    };
};



// WEBPACK FOOTER //
// ./src/state/reducer/analytics/actionCreators/initialize.js